<mat-selection-list [formControl]="formControl">
	<mat-list-option *ngFor="let option of selectOptions" [value]="option.value">
		{{option.label}}
	</mat-list-option>
</mat-selection-list>
